import { DashboardPageComponent } from 'components/Dahsboard/DashboardPageComponent';

const Dashboard = () => {
	return <DashboardPageComponent />;
};

export default Dashboard;
